import axiosClient from './axiosClient'

const packageApi = {
    getListPackages: () => {
        const url = '/list-co-bee-subscription-package'
        return axiosClient.get(url)
    },
    getListPayments: () => {
        const url = '/list-co-bee-subscription-payment'
        return axiosClient.get(url)
    },
    createPayment: (data) => {
        const url = '/create-co-bee-subscription-payment'
        return axiosClient.post(url, data)
    },
    cancelSubscription: (subPaymentId) => {
    const url = '/cancel-co-be-subscription-payment'
    return axiosClient.post(url, { subPaymentId })
  },
}
export default packageApi
